import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { LOAD_METROLOGY_DATA, SAVE_METROLOGY } from './actions';
import { METROLOGY_MODULE } from '../../configs/moduleNames';
import { createLoadParameterReducer, createOperationStateReducer } from '../../utils/getCrudConfig';

const initialState = {
  loadingSaveMetrology: false,
  loadingMetrologyData: false,
  metrologyData: {},
};

const reducer = handleActions({
  ...createLoadParameterReducer(METROLOGY_MODULE + LOAD_METROLOGY_DATA, 'metrologyData', 'loadingMetrologyData', {}),
  ...createOperationStateReducer(METROLOGY_MODULE + SAVE_METROLOGY, 'loadingSaveMetrology'),
}, initialState);

export default reducer;

export const getMetrologyData = createSelector(
  [state => state[METROLOGY_MODULE]],
  state => {
    const {
      loadingSaveMetrology,
      loadingMetrologyData,
      metrologyData,
    } = state;
    return {
      loadingSaveMetrology,
      loadingMetrologyData,
      metrologyData,
    };
  },
);
